import type { GroupType, TargetGroupFormValues } from './TargetGroups.types.ts';

export const getTargetGroupsValues = (
  data: TargetGroupFormValues & { entraGroupName: string },
) => ({
  id: data?.id || '',
  name: data?.name || '',
  active: data?.active || false,
  entraGroup: data?.entraGroupName
    ? [{ value: data.id || '', label: data.entraGroupName || '' }]
    : null,
});
export const getTargetGroupData = (
  values: { name: string; active: boolean },
  group: GroupType[],
) => ({
  name: values.name,
  active: values.active,
  entraGroupId: group[0]?.value,
  entraGroupName: group[0]?.label,
});